import { GetUserActionTypes, initialUserState } from '../types';
import createAsyncReducer from '~lib/shared/redux/reducers/async-reducer';

const RegisterUser = createAsyncReducer<string>(GetUserActionTypes.IMPORT_REGISTER_USER, initialUserState.user);

export default RegisterUser;
